import { FC, useState } from 'react';

import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import FileDownload from '@mui/icons-material/FileDownload';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FulfilmentOrder from '@/shared/types/fulfilment/order.type';

type ShippingLabelsDropdownProps = Pick<FulfilmentOrder, 'shipping_labels'>;

const ShippingLabelsDropdown: FC<ShippingLabelsDropdownProps> = ({
  shipping_labels,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatLinkLabel = (value: string) => {
    return value
      .split('/')
      .at(-1)
      ?.match(/.*?-\d+-(.+?)(?:\?|$)/)?.[1]
      .trim();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popover' : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant='contained'
        size='small'
        onClick={handleClick}
        endIcon={<ArrowDropDown sx={{ rotate: open ? '180deg' : '0' }} />}
      >
        Choose label
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={2}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Stack p={2}>
          <Typography variant='body1' sx={{ mb: 1 }}>
            Choose file to download:
          </Typography>

          <List dense>
            {shipping_labels.map((label) => (
              <ListItem key={label.url}>
                <ListItemIcon>
                  <FileDownload />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Link
                      key={label.url}
                      component='a'
                      target='_blank'
                      href={label.url}
                      download
                    >
                      {formatLinkLabel(label.url)}
                    </Link>
                  }
                  secondary={null}
                />
              </ListItem>
            ))}
          </List>
        </Stack>
      </Popover>
    </div>
  );
};

export default ShippingLabelsDropdown;
